import qs from 'qs';

export const getEventDeeplinkId = () => {
    const { playContentId } = qs.parse(window.location.search.slice(1));
    
    return playContentId;
};
